"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.page.login_page': 'Accesso',
    'app.page.registration_page': 'Registrazione',
};
